// 初期化関数を作成
function initializePopup() {
  // ポップアップ用のHTMLを一度だけbodyの末尾に追加
  if (!document.querySelector('.text-popup-overlay')) {
    document.body.insertAdjacentHTML('beforeend', 
      '<div class="text-popup-overlay"><div class="text-popup-content"><button type="button" class="text-popup-close" aria-label="閉じる">&times;</button><div class="text-popup-body"></div></div></div>'
    );
    
    // ポップアップを閉じる処理（オーバーレイまたは閉じるボタンクリック時）
    document.addEventListener('click', function(e) {
      const overlay = document.querySelector('.text-popup-overlay');
      // クリックされたのが背景か閉じるボタンの場合のみ閉じる
      if (e.target.classList.contains('text-popup-overlay') || e.target.classList.contains('text-popup-close')) {
        overlay.style.display = 'none';
      }
    });
  }

  // 対象となる要素（.trunc-with-popup）をすべて処理
  const truncElements = document.querySelectorAll('.trunc-with-popup');
  
  truncElements.forEach(function(element) {
    // 一度処理した要素はスキップする
    if (element.dataset.processed) {
      return;
    }

    const fullHtml = element.innerHTML; // 元のHTML（リンクなども含めて）を保持
    const textOnly = element.textContent; // 文字数カウント用にプレーンテキストを取得
    
    // 画面幅に応じて表示文字数を決定（PCなら100文字、スマホなら50文字）
    const trimLength = window.innerWidth > 782 ? 100 : 50;
    
    if (textOnly.length > trimLength) {
      const trimmedText = textOnly.substr(0, trimLength);
      element.innerHTML = trimmedText + '... <a href="#" class="read-more-link" style="cursor:pointer; color:black; text-decoration: none;">続きを読む</a>';
      
      // 「続きを読む」リンクがクリックされた時の動作
      const readMoreLink = element.querySelector('.read-more-link');
      readMoreLink.addEventListener('click', function(e) {
        e.preventDefault(); // リンクのデフォルト動作をキャンセル
        document.querySelector('.text-popup-body').innerHTML = fullHtml; // ポップアップに元のHTMLをセット
        document.querySelector('.text-popup-overlay').style.display = 'flex'; // ポップアップを表示
      });
    }
    
    // 処理済みのマークを付けて二重処理を防ぐ
    element.dataset.processed = 'true';
  });
}

// DOMContentLoaded時の初期化
document.addEventListener('DOMContentLoaded', initializePopup);

// 動的コンテンツ挿入後の再初期化用（グローバル関数として公開）
window.initializePopup = initializePopup;